(function () {
  var CONTENT = {
    swiss: {
      eyebrow: 'Livraison',
      title: 'Depuis la Suisse',
      icon: 'swiss',
      body: '<p>Toutes les commandes en stock sont <strong>préparées et expédiées depuis la Suisse</strong>, depuis notre entrepôt BNEXO.</p><ul><li>Expédition sous <strong>24h ouvrées</strong> pour les articles en stock</li><li>Livraison en Suisse en <strong>1 à 4 jours ouvrés</strong></li><li>Suivi colis envoyé par e-mail dès l\'expédition</li></ul>'
    },
    authentic: {
      eyebrow: 'Authenticité',
      title: '100% Authentique',
      icon: 'authentic',
      body: '<p>Chaque pièce BNEXO est <strong>100% officielle</strong> — Funko, TCG, manga, goodies : rien de contrefait, rien de « grey market ».</p><ul><li>Sourcée auprès de distributeurs et éditeurs reconnus</li><li>Contrôlée par notre équipe avant expédition</li><li>Preuve de sourcing sur demande</li></ul>'
    },
    package: {
      eyebrow: 'Protection',
      title: 'Emballage protégé',
      icon: 'package',
      body: '<p>Tes pièces voyagent comme elles le méritent. Nous adaptons l\'emballage au type de produit.</p><ul><li><strong>Cartes &amp; TCG</strong> : toploaders, sleeves, rigid mailers</li><li><strong>Figurines &amp; POP</strong> : bulles, calage, double carton si besoin</li><li>Colis assuré — contacte-nous sous 48h en cas de dommage</li></ul>'
    },
    payment: {
      eyebrow: 'Paiement',
      title: 'Paiement sécurisé',
      icon: 'payment',
      body: '<p>Paiement 100% sécurisé via <strong>Shopify Payments</strong>. Tes données bancaires ne sont jamais stockées chez BNEXO.</p><ul><li>Carte bancaire, TWINT, Apple Pay, Google Pay</li><li>Facture disponible après commande</li><li>Support réactif : <a href="mailto:info@bnexo.ch">info@bnexo.ch</a></li></ul>'
    }
  };

  var ICONS = {
    swiss: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="32" cy="54" rx="22" ry="5" fill="#09090B" opacity="0.12"/><path d="M14 38h36l-4 12H18l-4-12z" fill="#D4D4D8"/><path d="M16 28h32l-2 10H18l-2-10z" fill="#F4F4F5"/><rect x="24" y="26" width="16" height="10" rx="1.5" fill="#E63950"/><path d="M30 29v4M28 31h4" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>',
    authentic: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 10l18 7v12c0 10-6.5 17.5-18 20-11.5-2.5-18-10-18-20V17l18-7z" fill="#E63950"/><path d="M24 31l5 5 11-12" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    package: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 28l20-10 20 10v20l-20 10L12 48V28z" fill="#E4E4E7"/><circle cx="44" cy="36" r="8" fill="#E63950" opacity="0.85"/></svg>',
    payment: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="22" width="36" height="24" rx="4" fill="#27272A"/><rect x="38" y="34" width="14" height="16" rx="3" fill="#18181B"/><path d="M42 42h6v5h-6z" fill="#E63950"/></svg>'
  };

  function init() {
    var modal = document.getElementById('bnexo-trust-modal');
    if (!modal) return;

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    var eyebrow = document.getElementById('bnexo-trust-modal-eyebrow');
    var title = document.getElementById('bnexo-trust-modal-title');
    var body = document.getElementById('bnexo-trust-modal-body');
    var iconWrap = document.getElementById('bnexo-trust-modal-icon');
    var lastFocus = null;

    function open(key) {
      var data = CONTENT[key];
      if (!data) return;

      lastFocus = document.activeElement;
      eyebrow.textContent = data.eyebrow;
      title.textContent = data.title;
      body.innerHTML = data.body;
      iconWrap.innerHTML = ICONS[data.icon] || '';

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bnexo-trust-modal-open');
      modal.querySelector('.bnexo-trust-modal__close').focus();
    }

    function close() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('bnexo-trust-modal-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.querySelectorAll('[data-bnexo-trust]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(btn.getAttribute('data-bnexo-trust'));
      });
    });

    modal.querySelectorAll('[data-bnexo-trust-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (!modal.hidden && e.key === 'Escape') close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
